var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ChannelIcon',{staticClass:" cal_icon",staticStyle:{"width":"19px","height":"20px"}})}
var staticRenderFns = []

export { render, staticRenderFns }